import { IWeeklySchedulerAdapter } from '@captiveaire/weeklyscheduler';
import * as _ from 'lodash';
import { IDynamicCalendar } from '../shared/models/device';
import { DynamicModelWeeklySchedulerItem } from './dynamic-calendar-weekly-scheduler-item';
import { DynamicDTO } from './dynamic-dto.interface';

export class DynamicModelWeeklySchedulerAdapter implements IWeeklySchedulerAdapter<DynamicDTO, any> {
    public items: DynamicModelWeeklySchedulerItem[] = [];
    public initialData: DynamicDTO[];

    constructor(
        private data: IDynamicCalendar
    ) {
        this.initialData = this.buildInitialData();
    }

    public customModelToWeeklySchedulerRange(model: DynamicDTO) {
        return {
            $class: '',
            day: model.day,
            start: model.start,
            end: model.end,
            value: true
        };
    }

    public getSnapshot(): DynamicDTO[] {
        let result = Array.prototype.concat.apply([], this.items.map(item => {
            if (!item.schedules.length) {
                return {
                    day: item.day,
                    start: this.convertNullToNullValue(null),
                    end: this.convertNullToNullValue(null)
                };
            }

            return item.schedules.map(schedule => {
                return {
                    day: schedule.day,
                    start: this.convertNullToNullValue(schedule.start),
                    end: this.convertNullToNullValue(schedule.end)
                };
            });
        }));

        return _.sortBy(result, 'day', 'start');
    }

    public convertNullValueToNull(value: number): number {
        if (this.data.nullValue && value === this.data.nullValue) {
            return null;
        }

        return value;
    }

    public convertNullToNullValue(value: number) {
        if (this.data.nullValue && value === null) {
            return this.data.nullValue;
        }

        return value;
    }

    // initial data has to be in array format and is currently in object format
    private buildInitialData(): DynamicDTO[] {
        let result = [];

        let data = this.data;

        let days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

        days.forEach((day, index) => {
            let currentData: any = data[day];

            if (currentData) {
                currentData.items.forEach(item => {
                    let slot = item.value;

                    if (!slot.isVisible) {
                        return;
                    }

                    let start = this.convertNullValueToNull(slot.startTime.value);
                    let end = data.nullEnds ? null : this.convertNullValueToNull(slot.endTime.value);

                    // If start and end are BOTH missing, there are null values stored
                    // on the board & we shouldn't add a slot for that day -- if the user draws one in later that is fine
                    let hasStartAndEnd = !_.isUndefined(start) || !_.isUndefined(end);

                    if (hasStartAndEnd && start !== end) {
                        result.push({ day: index, start: start, end: end });
                    }
                });
            }
        });

        return _.sortBy(result, 'day', 'start');
    }
}
